import React from 'react';
import { isEmpty } from 'react-admin';
import { generatePath, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';

const SLOT_STATUS = {
    DISABLE: 0,
    DEFAULT: 1,
    ERROR: 2,
    REFILL: 3,
    OCCUPIED: 4,
};

const SlotItem = ({ slotNumber, colNumber, rowNumber, data, machineId, disable, is12Slots }) => {
    const { maxCapacity, totalQuantity, minCapacity, error, product } = data;

    const getStatus = () => {
        if(disable) return SLOT_STATUS.DISABLE;
        if(isEmpty(data) || Object.keys(data).length === 0) return SLOT_STATUS.DEFAULT;
        if(error) return SLOT_STATUS.ERROR;
        if(totalQuantity !== undefined && maxCapacity !== undefined && totalQuantity <= 0) return SLOT_STATUS.REFILL;
        return SLOT_STATUS.OCCUPIED;
    };
    
    const navigate = useNavigate();
    const status = getStatus();
    
    const handleClick = () => {
        if(!disable) {
            const path = generatePath("/machines/:machineId/slots/:slotNumber", { machineId, slotNumber });
            navigate(path);
        }
    };

    const renderProduct = () => {
        if (!product || !product.name) {
          return { text: "Add Product", fontSize: "14px" };
        }
      
        const productName = product.name;
        const length = productName.length;
      
        if (length > 50) {
          return { text: productName.substring(0, 50) + "...", fontSize: "12px" };
        } else if (length > 40) {
          return { text: productName, fontSize: "12px" };
        } else {
          return { text: productName, fontSize: "14px" };
        }
    };

    if(disable) {
        return <div></div>;
    } else {
        const { text: productText, fontSize } = renderProduct();
        return (
            <Box
                onClick={handleClick}
                className={`slot ${status === SLOT_STATUS.OCCUPIED ? "occupied" : status === SLOT_STATUS.ERROR ? "error" : status === SLOT_STATUS.REFILL ? "ofs" : "empty"}`}
            >
                <Typography variant="body2" className="slot-label">{colNumber}</Typography>
                <Typography variant="body1" fontWeight="bold" className="product-name" mt={1} style={{ fontSize }}>
                    {productText}
                </Typography>
                <Typography variant="body2" className="quantity" mt={1}>
                    {maxCapacity ? `${totalQuantity}/${maxCapacity}` : "-"}
                </Typography>
            </Box>
        );
    }
};

export default SlotItem;
